import { SelectOptionType } from "types/select/SelectOptionType";

export const NUMERO_WHATSAPP_SUPORTE = "553121035700";

export const opcoesProtocolo: SelectOptionType<string>[] = [
  { value: "IMAP", label: "IMAP" },
  { value: "POP", label: "POP" },
];
export const opcoesCriptografia: SelectOptionType<string>[] = [
  { value: "SSL", label: "SSL" },
  { value: "TLS", label: "TLS" },
];